import { UpdateWorkShiftDto, WorkShiftDto, WorkShiftPlanDto } from '@sr/dto';
import { salaryApi } from 'entities/salary/salary.api';

export type WorkShiftPeriodQuery = {
  year: number;
  month: number;
  dateFrom?: string;
  dateTo?: string;
  userId?: number;
};

export const workShiftsApi = salaryApi.injectEndpoints({
  endpoints: (builder) => ({
    getTodayWorkShiftPlan: builder.query<WorkShiftPlanDto, { date?: string } | void>({
      query: (arg) => ({
        url: arg && 'date' in arg && arg.date ? `work-shifts/today-plan?date=${arg.date}` : 'work-shifts/today-plan',
      }),
      providesTags: ['workShifts'],
    }),
    openWorkShift: builder.mutation<WorkShiftDto, void>({
      query: () => ({
        url: 'work-shifts/open',
        method: 'POST',
      }),
      invalidatesTags: ['workShifts'],
    }),
    closeWorkShift: builder.mutation<WorkShiftDto, number>({
      query: (id) => ({
        url: `work-shifts/${id}/close`,
        method: 'POST',
      }),
      invalidatesTags: ['workShifts'],
    }),
    getWorkShifts: builder.query<WorkShiftDto[], WorkShiftPeriodQuery>({
      query: ({ year, month, dateFrom, dateTo, userId }) => ({
        url: `work-shifts/${year}/${month}`,
        params: { dateFrom, dateTo, userId },
      }),
      providesTags: (result, error, query) => (result ? [{ type: 'workShifts', id: `${query.year}-${query.month}` }] : ['workShifts']),
    }),
    updateWorkShift: builder.mutation<WorkShiftDto, { id: number; data: UpdateWorkShiftDto; period?: WorkShiftPeriodQuery }>({
      query: ({ id, data }) => ({
        url: `work-shifts/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['workShifts'],
    }),
  }),
});
